module.exports = __webpack_public_path__ + "img/toabgnew.07d71997.png";